import { createContext } from "react";

export interface ToastsContextProps {
  success: (message: string) => void;
  error: (message: string, err: unknown) => void;
  addFailure: (entity: string, title: string | undefined, err: unknown) => void;
  addSuccess: (entity: string, title: string | undefined) => void;
  updateFailure: (entity: string, title: string | undefined, err: unknown) => void;
  updateSuccess: (entity: string, title: string | undefined) => void;
  deleteFailure: (entity: string, title: string | undefined, err: unknown) => void;
  deleteSuccess: (entity: string, title: string | undefined) => void;
  refreshSuccess: (entity: string, title: string | undefined) => void;
  refreshFailure: (entity: string, title: string | undefined, err: unknown) => void;
  saveSuccess: (entity: string, title: string | undefined) => void;
  saveFailure: (entity: string, title: string | undefined, err: unknown) => void;
}

export const ToastsContext = createContext({} as ToastsContextProps);
